import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import './InfoWindow.css';
export default function InfoWindow(props) {
  const [show, setShow] = useState(false);
  const [info, setInfo] = useState(props.info);
  const handleClose = () => setShow(false);
  function pokazOkno(info) {
    setInfo(info);
    setShow(true);
    const interval = setInterval(() => {
      setShow(false);
      clearInterval(interval);
    }, 1500);
  }
  
  // {props.biRef.someParentFunction()}
  props.biRef.pokazOkno = pokazOkno;
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={true}
        className="obramowanie-informacje"
      >
        <Modal.Header className="tytul-informacje" closeButton>
          <Modal.Title>Informacja</Modal.Title>
        </Modal.Header>
        <Modal.Body>
         {info}
          </Modal.Body>
        <Modal.Footer>
          <Button variant="success" onClick={handleClose}>
            Zamknij
            </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
